import Icon from 'components/Icon';

import classNames from 'classnames';
import {FC, useEffect, useState} from 'react';
import {SwiperClass} from 'swiper/react';
import style from './style.module.scss';

interface IProps {
    swiper?: SwiperClass;
}

export const NextButton: FC<IProps> = ({swiper}) => {
    const [isEnd, setIsEnd] = useState(false);

    useEffect(() => {
        if (swiper) {
            setIsEnd(swiper.isEnd);

            swiper.on('transitionEnd', (sw) => {
                setIsEnd(sw.isEnd);
            });
        }

        return () => {
            if (swiper) {
                swiper.off('transitionEnd');
            }
        };
    }, [swiper]);

    const handleClickNext = () => {
        if (!swiper) {
            return;
        }

        swiper.slideNext();
    };

    return (
        <button className={classNames(style.main, isEnd ? style.hidden : '')} onClick={handleClickNext} type={'button'}>
            <Icon className={style.icon} icon={'arrow'} />
        </button>
    );
};
